import { render, staticRenderFns } from "./MatchTheFollowing.vue?vue&type=template&id=3af1ae56"
import script from "./MatchTheFollowing.vue?vue&type=script&lang=js"
export * from "./MatchTheFollowing.vue?vue&type=script&lang=js"
import style0 from "./MatchTheFollowing.vue?vue&type=style&index=0&id=3af1ae56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports